import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { IHolidayDTO } from "../models/Holiday/Iholidaydto";
import { IHolidayCreateDTO } from "../models/Holiday/iholidaycreatedto";
import { IHolidayUpdateDTO } from "../models/Holiday/Iholidayupdatedto";
import { APIService } from "./APIService";
import { Parameter } from "../models/Parameter";

export class HolidayService {
  [x: string]: any;

  async GetHolidaById(
    id: number
  ): Promise<MessagingHelper<IHolidayDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Holiday/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(false, "Erro ao encontrar o feriado", null);
    }
  }
  
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<IHolidayDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Holiday/Getall`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<IHolidayDTO>(
        false,
        "Erro ao obter a informação dos feriados",
        "",
        [],
        0
      );
    }
  }

  async Create(
    createHoliday: IHolidayCreateDTO
  ): Promise<MessagingHelper<string>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Holiday/Create`,
        {
          ...createHoliday,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<string>(
        false,
        "Erro ao ligar ao servidor para criar o feriado",
        ""
      );
    }
  }

  async Edit(
    HolidayUpdate: IHolidayUpdateDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Holiday/Edit`,
        { ...HolidayUpdate },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para atualizar o feriado",
        null
      );
    }
  }
}
